module.exports = __webpack_public_path__ + "img/shipblu-verify.3f2a7e66.svg";